(($) => {
  $(() => {
    const $requiredFields = $('form [required]');

    if ($requiredFields.length) {
      $requiredFields.each((index, element) => {
        const $field = $(element);
        const requiredMessage = $field.data('required-message');

        if (requiredMessage) {
          $field.on('invalid', (event) => {
            event.target.setCustomValidity('');

            if (!event.target.validity.valid || !event.target.validity.typeMismatch) {
              event.target.setCustomValidity(requiredMessage);
            }
          });

          $field.on('input', (event) => {
            event.target.setCustomValidity('');
          });
        }
      });
    }
  });
})(jQuery);
